import React from 'react';
import FlexWrapper from 'ui/FlexWrapper';
import Wrapper from 'ui/Wrapper';
import Divider from 'ui/Divider';
import Text from 'ui/Text';
import ShoeInfo from 'features/ShoeInfo';
import { thousandsDots } from 'utils/formatters';

import getTexts from 'utils/localization';
const t = getTexts();

export function getStyledTextComponent(label, value, width) {
    return (
        <Wrapper width={width} padding="0px">
            <Text
                short={true}
                align="left"
                size="x05"
                padding="5px 5px 5px 0px"
            >
                <strong style={{ fontWeight: 900 }}>
                    {label ? label + ':' : ''}
                </strong>{' '}
                {value}
            </Text>
        </Wrapper>
    );
}

export const getCoach = (start) =>
    start && start.trainer && start.trainer.name && start.trainer.surName
        ? start.trainer.name + ' ' + start.trainer.surName
        : 'n/a';

export const getWeight = (start) =>
    start?.gallopStartInfo && start?.gallopStartInfo?.weight
        ? start.gallopStartInfo?.weight?.cardWeight
        : 'n/a';

export const getMoney = (start) =>
    start?.horseStat && start.horseStat.total?.earning?.sum
        ? thousandsDots(start.horseStat.total?.earning?.sum) +
          ' ' +
          start.horseStat.total?.earning?.currency
        : 'n/a';

export const getKRStart = (start) =>
    start.horseStat
        ? !start.horseStat.total?.earning?.sum ||
          !start.horseStat.total?.nrOfStarts
            ? 0
            : thousandsDots(
                  (
                      start.horseStat.total.earning.sum /
                      start.horseStat.total.nrOfStarts
                  ).toFixed(0)
              )
        : 'n/a';

export const getStarter = (start) => {
    const stat = start.horseStat;

    if (!stat?.total) {
        return '-';
    }

    return stat
        ? stat.total?.nrOfStarts +
              ' ' +
              stat.total?.first +
              '-' +
              stat.total?.second +
              '-' +
              stat.total?.third
        : 'n/a';
};

export const getFormtal = (start) => start.gallopStartInfo?.rating || '-';

const ShortStatistic = (props) => (
    <Wrapper padding="0px">
        <Divider grey margin="0px 0px 5px" />

        <FlexWrapper
            height="20px"
            width="auto"
            direction="row"
            align="space-between"
            padding="0px 15px"
        >
            {getStyledTextComponent(
                t.ShortStatistic.coach,
                getCoach(props.start),
                '40%'
            )}
            {!props.gallop
                ? getStyledTextComponent(
                      t.ShortStatistic.record,
                      props.start.getRecord(),
                      '30%'
                  )
                : getStyledTextComponent(
                      t.ShortStatistic.weight,
                      getWeight(props.start),
                      '30%'
                  )}
            {!props.gallop
                ? getStyledTextComponent(
                      t.ShortStatistic.shoe,
                      <ShoeInfo
                          frontShoe={
                              props.shoeInfo ? props.shoeInfo.front : null
                          }
                          backShoe={props.shoeInfo ? props.shoeInfo.back : null}
                      />,
                      '30%'
                  )
                : getStyledTextComponent(
                      'Formtal',
                      getFormtal(props.start),
                      '30%'
                  )}
        </FlexWrapper>

        <FlexWrapper
            height="20px"
            width="auto"
            direction="row"
            align="space-between"
            padding="0px 15px"
        >
            {getStyledTextComponent(
                t.ShortStatistic.money,
                getMoney(props.start),
                '40%'
            )}
            {getStyledTextComponent(
                t.ShortStatistic.start,
                getKRStart(props.start),
                '30%'
            )}
            {getStyledTextComponent(
                t.ShortStatistic.starter,
                getStarter(props.start),
                '30%'
            )}
        </FlexWrapper>

        <Divider grey margin="5px 0px 0px" />
    </Wrapper>
);

export default ShortStatistic;
